import { useAppSelector } from '~/hooks/useAppSelector';
import { ActiveShiftTabEnum } from '../enums';
import { useMemo } from 'react';

export const useActiveShifts = () => {
  const todayShiftsCount = useAppSelector((state) => state.job.dashboardInfo?.todayShift || 0);
  const reviewShiftsCount = useAppSelector(
    (state) => state.job.dashboardInfo?.pendingReviewJobCount || 0,
  );

  const activeTab = useMemo(() => {
    if (todayShiftsCount > 0) {
      return ActiveShiftTabEnum.Today;
    }

    if (reviewShiftsCount > 0) {
      return ActiveShiftTabEnum.PendingReview;
    }

    return ActiveShiftTabEnum.Today;
  }, [reviewShiftsCount, todayShiftsCount]);

  return {
    activeTab,
    counters: {
      todays: todayShiftsCount,
      reviews: reviewShiftsCount,
    },
  };
};
